import React, { ReactNode, CSSProperties } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  role?: string;
  id?: string;
  ariaLabelledBy?: string;
};

const ComparisonBaseCell = (props: Props) => (
  <div
    style={props.style}
    role={props.role}
    aria-labelledby={props.ariaLabelledBy}
    id={props.id}
    className={classNames('comparison-table-cell d-flex flex-column justify-content-center', props.className)}
  >
    {props.children}
  </div>
);

export default ComparisonBaseCell;
